import axios from "axios";
import {decodeBase64ToText} from "../utils/format-data";

const pendingEulaVersionKey = 'pendingEulaVersion';

export interface EulaAgreementResponse {
    version: string;
    content: string;    // base64
    createdAt: string;
    updatedAt: string;
}

export const termsService = {
    fetchEulaAgreement: async (): Promise<EulaAgreementResponse | null> => {
        const response = await axios.get(`eula/current`);

        if (response.status === 204) {
            return null;
        }

        if (response.status === 0) {
            return null;
        }

        return {
            ...response.data,
            content: decodeBase64ToText(response.data.content),
        };
    },

    createEulaAcceptance: async (version: string): Promise<void> => {
        await axios.post(`eula/accept`, { version });
    },

    setPendingEulaVersion: (version: string): void => {
        sessionStorage.setItem(pendingEulaVersionKey, version);
    },

    getPendingEulaVersion: (): string | null => {
        return sessionStorage.getItem(pendingEulaVersionKey);
    },

    clearPendingEulaVersion: (): void => {
        sessionStorage.removeItem(pendingEulaVersionKey);
    },
};